// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__CkCkO","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__-63lg"};